var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVatViesStatement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    "data-name": "Vrstva 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M57.1 83.7h52.2M57.1 95.4h52.2M57.1 107.1h52.2M121.8 59V41.7l-18.4-16.9H47.7c-2 0-3.6 1.6-3.6 3.6v92c0 2 1.6 3.6 3.6 3.6h70.5c2 0 3.6-1.6 3.6-3.6V59.1zM39.5 32H35c-2 0-3.6 1.6-3.6 3.6v77.5c0 2 1.6 3.6 3.6 3.6h4.5M26.9 39.3h-2.1c-2 0-3.6 1.6-3.6 3.6v63c0 2 1.6 3.6 3.6 3.6h2.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M103.4 24.8v16.8l18.4.1M73.5 60c-.3-1.1-1.3-4.1-1.6-5.5-.5-2.7.3-5.4.8-6.3.9-1.7 2.6-4.4 2.6-6.4 0-3.2-2.6-5.9-5.9-5.9H69c-3.2 0-5.9 2.6-5.9 5.9 0 1.9 1.7 4.6 2.6 6.4.7 1.3 1.2 4.2.8 6.3s-2 5.7-2 5.7M60.3 60.9h18v4.3h-18zM62.8 69h13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVatViesStatement);
export default __webpack_public_path__ + "static/media/VatViesStatement.cd5a8243bb2b9105825b8a28b2f6296f.svg";
export { ForwardRef as ReactComponent };